"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@icr-ui/utils");
const spacings = {
    s0: (0, utils_1.pxToRem)(2),
    s1: (0, utils_1.pxToRem)(4),
    s2: (0, utils_1.pxToRem)(8),
    s3: (0, utils_1.pxToRem)(12),
    s4: (0, utils_1.pxToRem)(16),
    s5: (0, utils_1.pxToRem)(20),
    s6: (0, utils_1.pxToRem)(24),
    s7: (0, utils_1.pxToRem)(32),
    s8: (0, utils_1.pxToRem)(40),
    s9: (0, utils_1.pxToRem)(48),
    s10: (0, utils_1.pxToRem)(56),
    s11: (0, utils_1.pxToRem)(64),
    s12: (0, utils_1.pxToRem)(80), //5rem
};
exports.default = spacings;
//# sourceMappingURL=spacings.js.map